import DomActions from '../actions/DomActions';
import Reflux from 'reflux';
export var DomReadyStore = Reflux.createStore(
{
	init:function()
	{
		this.listenTo(DomActions.domReady,'onDomReady');
	},
    onDomReady()
    {
		this.trigger();
    }
});

export var PopUpDomReadySotre = Reflux.createStore({

		init:function()
		{
			this.listenTo(DomActions.popUpDomReady,'onPopUpDomReady')
		},
		onPopUpDomReady()
		{
			this.trigger();
		}
});

export var LookupBeforeCloseStore = Reflux.createStore({
	
	init:function()
	{
		this.listenTo(DomActions.lookupBeforeClose,'onLookupBeforeClose');
	},
	onLookupBeforeClose(entityId,innerId)
	{
		this.trigger(entityId,innerId);
	}

});


// WEBPACK FOOTER //
// ./src/stores/DomStores.js